import {SubscriptionPaymentsHistoryDto} from '../dtos/subscriptionPaymentsHistory.dto';
import {SubscriptionSource, SubscriptionSourceUtils} from 'common';

export class RecentAccountPaymentsReportAccountDataViewModel {
    private static readonly MONTHLY = 'monthly';

    code: string;
    position: number;
    fullName: string;
    email: string;
    lastSubscription: string;
    lastSubscriptionPeriodUnit: string;
    expirationDate: number;
    lastPaymentDate: number;
    firstPaymentDate: number;
    lastSubscriptionSource: string;
    amount: number;
    discount: number;
    renewalStatus: boolean;
    active: boolean;

    public from(reports: SubscriptionPaymentsHistoryDto[]): RecentAccountPaymentsReportAccountDataViewModel[] {
        const data = [];
        let count = 0;
        // We want only accounts that have no renewable subscriptions
        reports.filter(report => report.subscriptions.every(sub => !sub.renewalStatus))
            .forEach((report) => {
                count++;
                const convertedData = new RecentAccountPaymentsReportAccountDataViewModel();
                convertedData.position = count;
                convertedData.code = report.code;
                convertedData.fullName = report.fullName;
                convertedData.email = report.email;
                // Find firstPaymentDate of account
                let firstPaymentDate = 0;
                report.subscriptions.flatMap(sub => sub.payments).forEach(payment => {
                    if (firstPaymentDate === 0) {
                        firstPaymentDate = payment.paymentDate;
                    } else if (payment.paymentDate < firstPaymentDate) {
                        firstPaymentDate = payment.paymentDate;
                    }
                });
                convertedData.firstPaymentDate = firstPaymentDate;

                // Find lastPaymentDate and expiration date based on latest subscription.
                const latestAccountSubscription = report.subscriptions
                    .sort((a, b) => b.subscribedOn - a.subscribedOn)[0];
                convertedData.lastSubscription = latestAccountSubscription.subscription;
                convertedData.lastSubscriptionSource =
                    SubscriptionSourceUtils.title(latestAccountSubscription.subscriptionSource as SubscriptionSource);
                convertedData.lastSubscriptionPeriodUnit = latestAccountSubscription.subscriptionPeriodUnit;

                convertedData.lastPaymentDate = latestAccountSubscription.lastPayment;
                if (convertedData.lastSubscriptionSource === SubscriptionSourceUtils.title(SubscriptionSource.ESHOP)) {
                    const isMonth = convertedData.lastSubscriptionPeriodUnit === RecentAccountPaymentsReportAccountDataViewModel.MONTHLY;
                    const date = new Date(convertedData.lastPaymentDate);

                    convertedData.expirationDate = isMonth ? date.setMonth(date.getMonth() + 1) : date.setFullYear(date.getFullYear() + 1);
                } else {
                    convertedData.expirationDate = latestAccountSubscription.expirationDate;
                }



                convertedData.renewalStatus = false; // This is always false here.
                convertedData.active = report.subscriptions.some(sub => sub.active);
                let amount = 0;
                let discount = 0;
                report.subscriptions.flatMap(sub => sub.payments)
                    .filter(payment => !payment.trial)
                    .forEach(payment => {
                        amount += payment.amount;
                        discount += payment.discount;
                    });
                convertedData.amount = Number(amount.toFixed(2));
                convertedData.discount = Number(discount.toFixed(2));

                data.push(convertedData);
        });

        return data;
    }
}
